module.exports = __webpack_public_path__ + "static/bannerBg-201b6e6f6977aaaffbd59c3bfe6c3c5f.png";